import * as React from 'react';
import WrapSymbols from '../../ui/WrapSymbols';
import { IBoxProps } from '@lce/slice';
import { scriptFunction } from '../../lib/util';

import * as Styled from './LtoText.style';

export interface ILtoTextProps extends IBoxProps {
  heading: string;
  hours?: string;
  script: {
    text: string;
    size: string | null;
  };
  scriptHoursAboveHeader?: boolean;
  subheading?: string;
  template: string;
  text?: string;
  regMark?: string;
  textRegMark?: string;
  isThin?: boolean;
}

export const LtoText: React.FC<ILtoTextProps> = ({
  children,
  script: { text: scriptText, size },
  scriptHoursAboveHeader = false,
  hours,
  heading,
  subheading,
  text,
  template,
  textRegMark,
  regMark,
  isThin = false,
  ...props
}) => (
  <Styled.LtoText data-testid="LtoText" as="h2" isThin={isThin} {...props}>
    {scriptText && scriptHoursAboveHeader && (
      <Styled.Hnr data-testid="HnrScript" as="span">
        <Styled.Script fontSize={scriptFunction(size, template)} tilt={3}>
          <WrapSymbols string={scriptText} wrapper={Styled.HnrSymbol} />
        </Styled.Script>
        <Styled.RegMark isThin={isThin}>{regMark}</Styled.RegMark>
        {hours && <Styled.Hours as="span">{hours}</Styled.Hours>}
      </Styled.Hnr>
    )}
    <Styled.Heading as="span" isThin={isThin}>
      <WrapSymbols string={heading} wrapper={Styled.HeadingSymbol} />
    </Styled.Heading>
    {subheading && (
      <Styled.Subheading as="span" isThin={isThin}>
        <WrapSymbols string={subheading} wrapper={Styled.SubheadingSymbol} />
      </Styled.Subheading>
    )}
    {scriptText && !scriptHoursAboveHeader && (
      <Styled.Hnr data-testid="HnrScript" as="span">
        <Styled.Script fontSize={scriptFunction(size, template)}>
          <WrapSymbols string={scriptText} wrapper={Styled.HnrSymbol} />
        </Styled.Script>
        <Styled.RegMark isThin={isThin}>{regMark}</Styled.RegMark>
        {hours && <Styled.Hours as="span">{hours}</Styled.Hours>}
      </Styled.Hnr>
    )}
    {text && (
      <Styled.TextWrapper isThin={isThin}>
        <Styled.Text as="span" isThin={isThin}>
          <WrapSymbols string={text} wrapper={Styled.TextSymbol} />
          <Styled.TextRegMark as="span">{textRegMark}</Styled.TextRegMark>
        </Styled.Text>
      </Styled.TextWrapper>
    )}
    {children}
  </Styled.LtoText>
);
